<!-- 更新账单开票状态 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody:{
                "parkCode": "2KNRNIJC",
                "billList": [{
                    "billCode": "",
                    "parkingCode": ""
                },{
                    "billCode": "",
                    "parkingCode": ""
                }],
                "invoiceClient": "",
                "invoiceNumber": "",
                "invoiceStatus": 1,
                "invoiceTime": "20210922115900",
                "invoiceTitle": "",
                "invoiceTitleType": 0
                },
            responseCode: {
    "data": {},
    "message": "业务成功",
    "resultCode": 0,
    "status": 1
},
            infoData: {
                explain: "第三方接入系统同步用户缴费信息到智慧停车开放平台",
                t_url: this.commonUrls.test + "updateInvoiceStatusOfPayBill",
                p_url: this.commonUrls.prod + "updateInvoiceStatusOfPayBill",
                precondition: "查询车场支付账单后调用，平台存在的账单",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'billList', info2: '是', info3: 'JSONArray', info4: '流水号列表(包括停车流水，账单流水)' },
                        { info1: 'invoiceStatus', info2: '是', info3: 'Integer', info4: '开票状态: 注意阅读(\
                        0新建(提交到开票商未回调-通知平台不能为其账单开票)，\
                        1已开票，\
                        2冲红(更新为已冲红的账单)，\
                        3(已废除)，\
                        4失败(可为账单更新状态)))' },
                        { info1: 'invoiceNumber', info2: '否', info3: 'String', info4: '开票号码(开票状态为“已开票”时必填)' },
                        { info1: 'invoiceTime', info2: '否', info3: 'String', info4: '开票时间(开票状态为“开票中”、“已开票”时必填) yyyyMMddHHmmss' },
                        { info1: 'invoiceClient', info2: '否', info3: 'String', info4: '开票用户端(开票状态为“开票中”、“已开票”时必填) 长度限制20' },
                        { info1: 'invoiceTitleType', info2: '否', info3: 'Integer', info4: '发票抬头类型（0个人，1公司）(开票状态为“开票中”、“已开票”,时必填)' },
                        { info1: 'invoiceTitle', info2: '否', info3: 'String', info4: '发票抬头(开票状态为“开票中”、“已开票”,时必填)' },   
                    ]
                },{
                    titleName: 'billList流水号列表(包括停车流水，账单流水)',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水号' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '账单流水号' },
                        { info1: 'billType', info2: '否', info3: 'Integer', info4: '账单类型: 0 停车；1 月票，默认0' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                  ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/invoice/updateInvoiceStatusOfPayBill.vue